import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageTitle from "../../components/shared/PageTitle";
import AccountWidget from "../../components/shared/AccountWidget";
import { Link } from "react-router-dom";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import Loading from "../../components/shared/Loading";
import { fetchOrders } from "../../store/actions/order";
import styles from "../../thema/style";
import moment from "moment";
import "moment/locale/tr";
moment.locale("tr");

class AccountOrdersHistory extends Component {
  componentDidMount() {
    this.props.fetchOrders();
  }

  render() {
    if (this.props.customer.fetching) {
      return <Loading text={"Sayfa Yükleniyor..."} />;
    } else {
      if (!this.props.customer.customer) {
        return (
          <Redirect
            to={{
              pathname: "/giris-yap"
              // state: { referrer: currentLocation }
            }}
          />
        );
      }
      const orders = this.props.order.orders.filter(
        ({ status }) => status === "Tamamlandı"
      );
      return (
        <React.Fragment>
          <PageTitle title={"Sipariş Geçmişim"} />
          <div className="row">
            <div className={"container"}>
              <div className="row">
                <div className={"col-md-9"} style={{ marginTop: 15 }}>
                  <h2>Sipariş Geçmişim</h2>
                  <span className="text-small">Tamamlanan Siparişleriniz</span>
                  {this.props.order.fetching ? (
                    <Loading text={"Siparişler Yükleniyor..."} />
                  ) : orders.length > 0 ? (
                    <table
                      className={styles.orderListTable}
                      style={{ marginTop: 10 }}
                    >
                      <thead>
                        <tr>
                          <th>SİPARİŞ NO</th>
                          <th>SİPARİŞ DURUMU</th>
                          <th>SİPARİŞ TARİHİ</th>
                          <th>ÜRÜN SAYISI</th>
                          <th>TOPLAM</th>
                          <th>&nbsp;</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orders.map((order, i) => (
                          <tr key={i}>
                            <td>{order.c_number}</td>
                            <td>{order.status}</td>
                            <td>
                              {moment(order.created_at).format("DD/MM/YYYY")}
                            </td>
                            <td>{order.products.length}</td>
                            <td>₺{order.total_price}</td>
                            <td>
                              <Link
                                className={"btn btn-success"}
                                to={{
                                  pathname: "/hesabim/siparis/detay",
                                  state: {
                                    id: order.id
                                  }
                                }}
                              >
                                <FontAwesomeIcon icon={["fas", "eye"]} />
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div>Tamamlanan siparişiniz bulunmamaktadır.</div>
                  )}
                </div>
                <div className={"col-md-3"}>
                  <AccountWidget />
                  <CategoriesWidget />
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
}

const mapStateToProps = ({ customer, order }) => {
  return { customer, order };
};

const mapDispatchToProps = { fetchOrders };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountOrdersHistory);



// WEBPACK FOOTER //
// ./src/routers/Account/orders_history.js